import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import authenUtility from '../../Utilitys/Authentication';

const PrivateRoute = ({ component: Component, ...rest }) => (
   <Route
      {...rest}
      render={props => (!authenUtility.isLogin() ? <Redirect to="/" /> : <Component {...props} />)}
   ></Route>
);

PrivateRoute.propTypes = {
   component: PropTypes.elementType.isRequired,
};
export default PrivateRoute;
